import { render, staticRenderFns } from "./TsLoadingBanner.vue?vue&type=template&id=064da6de&scoped=true&"
import script from "./TsLoadingBanner.vue?vue&type=script&lang=js&"
export * from "./TsLoadingBanner.vue?vue&type=script&lang=js&"
import style0 from "./TsLoadingBanner.vue?vue&type=style&index=0&id=064da6de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064da6de",
  null
  
)

export default component.exports